import { createSlice } from '@reduxjs/toolkit';

export const optionSlice = createSlice({
  name: 'option',
  initialState: {
    selectedOption: 'PRICE',
  },
  reducers: {
    setOption: (state, action) => {
      state.selectedOption = action.payload;
    },
  },
});

export const { setOption } = optionSlice.actions;

// export default optionSlice.reducer;
